import { render, staticRenderFns } from "./use-cases-business.vue?vue&type=template&id=7ce3f2e2&scoped=true"
import script from "./use-cases-business.vue?vue&type=script&lang=js"
export * from "./use-cases-business.vue?vue&type=script&lang=js"
import style0 from "./use-cases-business.vue?vue&type=style&index=0&id=7ce3f2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce3f2e2",
  null
  
)

export default component.exports